
import dayjs from 'dayjs'
import CompanySearch from '~/components/Common/UI/Search/CompanySearch'
import SearchDate from '~/components/Common/UI/Search/SearchDate'
import CorpSearch from '~/components/Common/UI/Search/CorpSearch'
import SearchInputField from '~/components/Common/UI/Search/SearchInputField'
export default {
    components: {
        SearchDate,
        CorpSearch,
        CompanySearch,
        SearchInputField,
    },
    props: {
        dateText: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            selectSearch: 'company',
            inputText: '',
            date: '',
        }
    },
    watch: {
        date() {
            if (this.date !== '') {
                this.getDate()
            }
        },
        selectSearch(){
            // 220519 meej 조회타입변경 시 date 초기화 추가
            this.date = ''
        }
    },
    methods: {
        selectSearchItem(value) {
            if (!value) {
                this.$emit('default')
            }
            this.selectSearch = value
        },
        getCode(code) {
            this.$emit('corpcode', code)
        },
        getDate() {
            this.$emit('date', dayjs(this.date).format('YYYYMMDD'))
        },
    },
}
